import { render, staticRenderFns } from "./LowerThirdPropertyMobile.vue?vue&type=template&id=6235bafa&"
import script from "./LowerThirdPropertyMobile.vue?vue&type=script&lang=js&"
export * from "./LowerThirdPropertyMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports